var map = {
	"./2017.jpg": "beXc",
	"./2018.jpg": "O1KD",
	"./2019.jpg": "v4Oc",
	"./2021.12-2022.11.jpg": "3Zrl",
	"./2021.7.15.jpg": "89dV",
	"./2022.12.jpg": "MKDt",
	"./2023.11.jpg": "qzoL",
	"./2023.3.jpg": "3xmg",
	"./banner.jpg": "CxsO",
	"./bannermachine.png": "iIyq",
	"./bottomimg.png": "7oA1",
	"./cp-1.jpg": "CLhD",
	"./unit-1.png": "5Eq8",
	"./unit-2.png": "+Tt3",
	"./unit-3.png": "HDcC",
	"./unit-4.png": "i7U+",
	"./unit-5.png": "cILh",
	"./unit-6.png": "VdUE",
	"./unit-7.jpg": "8DkS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "L9i6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic ^\.\/.*$
// module id = L9i6
// module chunks = 2 5